import AxiosService from './AxiosService'
class ActiveDirectoryRestService {

  adConfigAPI = "/activedirectory/config"
  adMappingAPI = "/activedirectory/mapping"

  getBasicConfig(): Promise<any> {
    return AxiosService.get(this.adConfigAPI)
  }

  configureBasic(adConfig: any): Promise<any> {
    return AxiosService.put(this.adConfigAPI, adConfig)
  }

  getCertificate(): Promise<any> {
    return AxiosService.get(this.adConfigAPI + '/certificate', { responseType: 'blob' })
  }

  configureCertificate(certificate: any): Promise<any> {
    return AxiosService.post(this.adConfigAPI + '/certificate', certificate)
  }

  testConnection(): Promise<any> {
    return AxiosService.put(this.adConfigAPI + '/testconnection')
  }

  deleteConfig(): Promise<any> {
    return AxiosService.delete(this.adConfigAPI)
  }

  getAdMapping(): Promise<any> {
    return AxiosService.get(this.adMappingAPI)
  }

  createAdMapping(adMapping: any): Promise<any> {
    return AxiosService.post(this.adMappingAPI, adMapping)
  }

  importAdMappings(searchBase: string): Promise<any> {
    return AxiosService.post(this.adMappingAPI + '/import', searchBase, { headers: { 'Content-Type': 'text/plain' } })
  }

  changeAdMapDescription(id: number, description: string): Promise<any> {
    return AxiosService.put(this.adMappingAPI + `/${id}`, description, { headers: { 'Content-Type': 'text/plain' } })
  }

  deleteMapping(id: number): Promise<any> {
    return AxiosService.delete(this.adMappingAPI + `/${id}`)
  }

  getAssignedRoles(id: number): Promise<any> {
    return AxiosService.get(this.adMappingAPI + `/${id}/roles`)
  }

  updateAssignedRoles(id: number, roles: any[]): Promise<any> {
    return AxiosService.put(this.adMappingAPI + `/${id}/roles`, roles)
  }
}

export default new ActiveDirectoryRestService()
